<aside
  class="course-navigation-panel"
  [class.collapsed]="collapsed()"
  [class.has-overflow]="hasOverflow()"
>
  <button
    type="button"
    class="panel-header"
    [attr.aria-label]="(collapsed()
      ? 'h5pPlayer.courseNavigation.expand'
      : 'h5pPlayer.courseNavigation.collapse') | translate"
    [attr.aria-expanded]="!collapsed()"
    [attr.aria-controls]="panelBodyId"
    (click)="toggle()"
  >
    <mat-icon class="toggle-icon size-m">menu_open</mat-icon>
    @if (!collapsed()) {
      <h2 class="panel-title">
        {{ 'h5pPlayer.courseNavigation.title' | translate }}
      </h2>
    }
  </button>

  <div [id]="panelBodyId" class="panel-body">
    @for (section of viewModel(); track section.id) {
        <section class="nav-section">
          <h3 class="section-title">{{ section.title }}</h3>

          @for (item of section.items; track item.id) {
            @if (item.kind === ITEM_KINDS.LABEL) {
              <div
                class="label-row"
                [class.interactive]="item.overflowing()"
                [class.expanded]="item.textExpanded()"
                [attr.role]="item.overflowing() ? 'button' : null"
                [attr.tabindex]="item.overflowing() ? 0 : null"
                [attr.aria-expanded]="item.overflowing() ? item.textExpanded() : null"
                (click)="onLabelActivate(item)"
                (keydown.enter)="onLabelKeydown(item, $event)"
                (keydown.space)="onLabelKeydown(item, $event)"
              >
                <div class="label-text-wrapper">
                  <span
                    class="label-text"
                    appLabelOverflow
                    [expanded]="item.textExpanded()"
                    (overflowChange)="setLabelOverflowing(item.id, $event)"
                  >{{ item.text || '-' }}</span>
                  @if (item.overflowing()) {
                    <mat-icon class="label-chevron size-s">
                      {{ item.textExpanded() ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  }
                </div>
                <span class="status-column label-status" aria-hidden="true">
                  <span class="line-segment line-top" [class.line-hidden]="item.isFirstItem"></span>
                  <span class="label-dot"></span>
                  <span class="line-segment line-bottom" [class.line-hidden]="item.isLastItem"></span>
                </span>
              </div>
            } @else {
              <div
                class="module-row"
                [class.locked]="item.locked"
                [class.active]="item.active"
                [class.interactive]="!item.locked && !item.active"
                [attr.role]="!item.locked && !item.active ? 'button' : null"
                [attr.tabindex]="!item.locked && !item.active ? 0 : null"
                [attr.aria-disabled]="item.locked ? true : null"
                [attr.data-activity-id]="item.id"
                [matTooltip]="collapsed() ? item.title : ''"
                matTooltipPosition="left"
                (click)="onModuleActivate(item)"
                (keydown.enter)="onModuleKeydown(item, $event)"
                (keydown.space)="onModuleKeydown(item, $event)"
              >
                <div class="module-text">
                  <div class="module-title">{{ item.title || '-' }}</div>
                  <span class="module-type">{{ (item.typeKey | translate) || '-' }}</span>
                </div>
                <span
                  class="status-column module-status"
                  [attr.aria-label]="('h5pPlayer.courseNavigation.status.' + item.status) | translate"
                >
                  <span class="line-segment line-top" [class.line-hidden]="item.isFirstItem"></span>
                  @switch (item.status) {
                    @case (MODULE_STATUSES.ACTIVE) {
                      <span class="status-dot"></span>
                    }
                    @case (MODULE_STATUSES.NOT_STARTED) {
                      <span class="status-circle"></span>
                    }
                    @default {
                      <mat-icon
                        class="size-s"
                        [class]="item.statusClass"
                      >{{ item.statusIcon }}</mat-icon>
                    }
                  }
                  <span class="line-segment line-bottom" [class.line-hidden]="item.isLastItem"></span>
                </span>
              </div>
            }
          }
        </section>
    }
  </div>
</aside>
